/* template */
<template><div class="mpx-root-view"><es-layout :leftArrow="(true)" navbarTitle="退款详情" :navbarStyle="(navbarStyle)" :esMainStyle="(esMainStyle)" :navbarUseRight="(isShowDiscount)"><mpx-view @tap="showDrawer" slot="narbar-right">规则</mpx-view><div class="header"><es-icon size="22" name="coin-circle"></es-icon><div class="info"><div class="info-content">退款总额：{{refundTotal}}元</div><div class="info-tip">通过其他途径改签或退票产生的退款</div></div><mpx-view @tap="refundConfirm" class="btn" v-if="(refunds.length)">立即退款</mpx-view></div><div class="content"><div v-for="(item, index) in (refunds)" :key="item.index" class="refund">线下改签退票退款：<div class="price">{{item.return_price}}</div>元</div><div class="refund" v-if="(isShowDiscount)">订单优惠金额扣减：<div class="price">-{{discountTotal}}</div>元</div></div></es-layout><drawer-frame title="退改规则说明" :open="(openDrawer)" @closeDrawer="closeDrawer"><div class="refund-desc-container"><div v-for="(item, index) in (refundOfflineDesc)" class="desc-item">{{item}}</div></div></drawer-frame><es-dialog id="es-dialog"></es-dialog></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m2688eec4"}'>
	.header
		height 68px
		padding 16px 15px 0 24px
		display flex
		align-items flex-start
		justify-content space-between
		color #fff
		letter-spacing 0px
		.info
			flex 1
			padding 0 4px
			&-content
				font-family PingFangSC-Semibold
				font-size 18px
				line-height 22px
			&-tip
				margin-top 5px
				font-family PingFangSC-Regular
				font-size 12px
				line-height 18px
		.btn
			flex none
			width 98px
			height 36px
			display flex
			align-items center
			justify-content center
			border 1px solid #FFFFFF
			background-color transparent
			border-radius 8px
			font-family PingFangSC-Medium
			font-size 14px
	.content
		padding 12px 12px 40px
		min-height 50vh
		border-radius 16px 16px 0 0
		background-image linear-gradient(179deg, #FAFBFD 0%, #F0F1F4 6%, #F0F1F4 100%)
		.refund
			height 50px
			border-radius 8px
			background-color #fff
			display flex
			align-items center
			font-size 16px
			font-family PingFangSC-Medium
			letter-spacing 0px
			color #000000
			padding 0 12px
			&+.refund
				margin-top 10px
			.price
				display inline
				color #1473FF
	.refund-desc-container
		margin 0 12px
		padding 8px 12px
		margin-bottom 32px
		.desc-item
			margin-bottom 8px
			font-family PingFangSC-Regular
			line-height 18px
			color #666
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m2688eec4"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./refund-offline.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./refund-offline.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m2688eec4"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'drawer-frame':getComponent(require("../../components/coupon/drawer-frame/index.mpx?isComponent&outputPath=components%2Findex5c33f4ce%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
